<template>
  <div
    id="app"
    ref="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: "App",
  updated() {
    this.$nextTick(() => {
      this.refresh();
    });
  },
  methods: {
    created() {
      let frame = window.frameElement;
      if (frame) {
        frame.style.border = "none";
        frame.style.width = "100%";
        frame.style.overflow = "hidden";
      }
      this.refresh();
    },
    refresh() {
      let frame = window.frameElement;
      if (frame) {
        const docHeight = this.$refs.app.scrollHeight;

        window.frameElement.style.height = docHeight + "px";
      }
    }
  },
  timers: {
    refresh: { time: 100, autostart: true, repeat: true }
  }
};
</script>

<style>
body {
  margin: 0;
  background-image: url(assets/Brotherilkeld-copyright-Nick-Thorne.jpg);
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /*margin-top: 60px;*/
}
</style>



// WEBPACK FOOTER //
// src/App.vue